import { render, staticRenderFns } from "./index.vue?vue&type=template&id=502325bc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/app/components/banner/Banner.vue').default,ListHeader: require('/app/components/list/ListHeader.vue').default,ListNote: require('/app/components/list/ListNote.vue').default,ListLinkMore: require('/app/components/list/ListLinkMore.vue').default,ListAlbum: require('/app/components/list/ListAlbum.vue').default,ListNews: require('/app/components/list/ListNews.vue').default})
